module.exports = __webpack_public_path__ + "img/promo-2.08dcb47e.png";